<div class="promotion-box" *ngIf="hasPromotion">
                    <span class="promotion-text">{{title}}</span>
                </div>